import { render, staticRenderFns } from "./TeacherView.vue?vue&type=template&id=478c795e&scoped=true&"
import script from "./TeacherView.vue?vue&type=script&lang=js&"
export * from "./TeacherView.vue?vue&type=script&lang=js&"
import style0 from "./TeacherView.vue?vue&type=style&index=0&id=478c795e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478c795e",
  null
  
)

export default component.exports